import QrCodeList from "./QrCodeList";

export default QrCodeList